import ChatMessages from './ChatMessages';

export default ChatMessages;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/index.js